import type { NodeItem } from '@models/flows';
import { v4 as uuidv4 } from 'uuid';

import { NodeTypes } from './node-types';

const getInitialNodeItem = (nodeType: string): NodeItem => {
  switch (nodeType) {
    case NodeTypes.errorNode:
      return { id: uuidv4(), label: '' };
    case NodeTypes.settingsNode:
      return { id: uuidv4(), label: '' };
    case NodeTypes.conditionalNode:
      return { id: uuidv4(), code: '', label: '', value: [] };
    case NodeTypes.testGroupsNode:
      return { id: uuidv4(), value: [''] };
    case NodeTypes.transactionNatureNode:
      return { id: uuidv4(), code: '', label: '' };
    case NodeTypes.recurringActionNode:
      return {
        id: uuidv4(),
        action: '',
        maxRetries: 0,
        retryInterval: { days: 0, hours: 0, minutes: 0 },
      };
    case NodeTypes.valueNode:
      return { id: uuidv4(), code: 'number', value: '', label: '' };
    case NodeTypes.debtCollectionNode:
      return { id: uuidv4(), code: 'debt_flow', value: true };
    case NodeTypes.failureNode:
      return { id: uuidv4(), code: 'number', value: '', label: '' };
    case NodeTypes.successNode:
      return {
        id: uuidv4(),
        retryInterval: { days: 0, hours: 0, minutes: 0 },
      };
    default:
      return { id: uuidv4() };
  }
};

export const getInitialNodeData = (nodeType: string) => {
  switch (nodeType) {
    case NodeTypes.errorNode:
      return { items: [initialErrorNodeData] };
    case NodeTypes.settingsNode:
      return { items: [initialSettingsNodeData] };
    case NodeTypes.conditionalNode:
      return { items: [initialConditionalNodeData] };
    case NodeTypes.testGroupsNode:
      return { items: [initialTestGroupsNode] };
    case NodeTypes.transactionNatureNode:
      return { items: [initialTransactionNatureNode] };
    case NodeTypes.recurringActionNode:
      return { items: [initialRecurringActionNode] };
    case NodeTypes.valueNode:
      return { items: [initialValueNodeData] };
    case NodeTypes.debtCollectionNode:
      return { items: [initialDebtCollectionNodeData] };
    case NodeTypes.failureNode:
      return { items: [initialFailureNodeData] };
    case NodeTypes.successNode:
      return { items: [initialSuccessNodeData] };
    default:
      return {};
  }
};

export const initialValueNodeData = getInitialNodeItem(NodeTypes.valueNode);
export const initialDebtCollectionNodeData = getInitialNodeItem(NodeTypes.debtCollectionNode);
export const initialErrorNodeData = getInitialNodeItem(NodeTypes.errorNode);
export const initialSettingsNodeData = getInitialNodeItem(NodeTypes.settingsNode);
export const initialConditionalNodeData = getInitialNodeItem(NodeTypes.errorNode);
export const initialTestGroupsNode = getInitialNodeItem(NodeTypes.errorNode);
export const initialTransactionNatureNode = getInitialNodeItem(NodeTypes.transactionNatureNode);
export const initialRecurringActionNode = getInitialNodeItem(NodeTypes.recurringActionNode);
export const initialFailureNodeData = getInitialNodeItem(NodeTypes.failureNode);
export const initialSuccessNodeData = getInitialNodeItem(NodeTypes.successNode);

export const isNodeType = (nodeType: string, ...expectedTypes: string[]): boolean =>
  expectedTypes.length > 0 && expectedTypes.includes(nodeType);

export const isValueArray = (value: unknown): boolean => Array.isArray(value) && value.length > 0;
export const isValidNodeType = (nodeType: string): boolean => {
  return (Object.values(NodeTypes) as string[]).includes(nodeType);
};
